import React from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

const SuccessModal = (props) => {
  const data = props;
  return (
    <Modal
      isOpen={data?.isOpen || false}
      backdrop={false}
    >
      <ModalBody>
        <div
        // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: data?.message || '' }}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => data.onclickOK()}>OK</Button>
      </ModalFooter>
    </Modal>
  );
};

export default SuccessModal;
